import { render, staticRenderFns } from "./visaCard.vue?vue&type=template&id=3cca0d26&scoped=true&"
import script from "./visaCard.vue?vue&type=script&lang=js&"
export * from "./visaCard.vue?vue&type=script&lang=js&"
import style0 from "./visaCard.vue?vue&type=style&index=0&id=3cca0d26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca0d26",
  null
  
)

export default component.exports